import Accordion from "../components/Accordion";
import enero_estructura_datos from "../docs/lotaip/2024/enero/1.1 estructura-organica/Conjunto de datos.xlsx";
import enero_estructura_metadatos from "../docs/lotaip/2024/enero/1.1 estructura-organica/Metadatos.xlsx";
import enero_estructura_diccionario from "../docs/lotaip/2024/enero/1.1 estructura-organica/Diccionario de datos.xlsx";

import enero_base_datos from "../docs/lotaip/2024/enero/1.2 Base Legal-regulaciones-procedimientos internos/Conjunto de datos.xlsx";
import enero_base_metadatos from "../docs/lotaip/2024/enero/1.2 Base Legal-regulaciones-procedimientos internos/Metadatos.xlsx";
import enero_base_diccionario from "../docs/lotaip/2024/enero/1.2 Base Legal-regulaciones-procedimientos internos/Diccionario de datos.xlsx";

import enero_metas_datos from "../docs/lotaip/2024/enero/1.3 Metas y objetivos-unidades/Conjunto de datos.xlsx";
import enero_metas_metadatos from "../docs/lotaip/2024/enero/1.3 Metas y objetivos-unidades/Metadatos.xlsx";
import enero_metas_diccionario from "../docs/lotaip/2024/enero/1.3 Metas y objetivos-unidades/Diccionario de datos.xlsx";

import enero_directorio_datos from "../docs/lotaip/2024/enero/2. Directorio y distributivo personal de la entidad/Conjunto de datos.xlsx";
import enero_directorio_metadatos from "../docs/lotaip/2024/enero/2. Directorio y distributivo personal de la entidad/Metadatos.xlsx";
import enero_directorio_diccionario from "../docs/lotaip/2024/enero/2. Directorio y distributivo personal de la entidad/Diccionario de Datos.xlsx";

import enero_remuneraciones_datos from "../docs/lotaip/2024/enero/3. Remuneraciones ingresos adicionales_2/Conjunto de datos.xlsx";
import enero_remuneraciones_metadatos from "../docs/lotaip/2024/enero/3. Remuneraciones ingresos adicionales_2/Metadatos.xlsx";
import enero_remuneraciones_diccionario from "../docs/lotaip/2024/enero/3. Remuneraciones ingresos adicionales_2/Diccionario de datos.xlsx";

import enero_servicios_datos from "../docs/lotaip/2024/enero/5-22 Servicios -formularios-formatos-tramites_2/Conjunto de datos.xlsx";
import enero_servicios_metadatos from "../docs/lotaip/2024/enero/5-22 Servicios -formularios-formatos-tramites_2/Metadatos.xlsx";
import enero_servicios_diccionario from "../docs/lotaip/2024/enero/5-22 Servicios -formularios-formatos-tramites_2/Diccionario de datos.xlsx";

import enero_presupuesto_datos from "../docs/lotaip/2024/enero/6. Presupuesto de la institucion/Conjunto de datos.xlsx";
import enero_presupuesto_metadatos from "../docs/lotaip/2024/enero/6. Presupuesto de la institucion/Metadatos.xlsx";
import enero_presupuesto_diccionario from "../docs/lotaip/2024/enero/6. Presupuesto de la institucion/Diccionario de datos.xlsx";

import enero_planes_datos from "../docs/lotaip/2024/enero/10. Planes y programas/Conjunto de datos.xlsx";
import enero_planes_metadatos from "../docs/lotaip/2024/enero/10. Planes y programas/Metadatos.xlsx";
import enero_planes_diccionario from "../docs/lotaip/2024/enero/10. Planes y programas/Diccionario de datos.xlsx";

import enero_mecanismo_datos from "../docs/lotaip/2024/enero/12. Mecanismos rendicion cuentas_2/Conjunto de datos.xlsx";
import enero_mecanismo_metadatos from "../docs/lotaip/2024/enero/12. Mecanismos rendicion cuentas_2/Metadatos.xlsx";
import enero_mecanismo_diccionario from "../docs/lotaip/2024/enero/12. Mecanismos rendicion cuentas_2/Diccionario.xlsx";

import enero_responsables_datos from "../docs/lotaip/2024/enero/14. Responsables del acceso de informacion publica/Conjunto de datos.xlsx";
import enero_responsables_metadatos from "../docs/lotaip/2024/enero/14. Responsables del acceso de informacion publica/Metadatos.xlsx";
import enero_responsables_diccionario from "../docs/lotaip/2024/enero/14. Responsables del acceso de informacion publica/Diccionario.xlsx";

import enero_texto_datos from "../docs/lotaip/2024/enero/15. Texto integro de los contratos colectivos vigentes y reformas/Conjunto de datos.xlsx";
import enero_texto_metadatos from "../docs/lotaip/2024/enero/15. Texto integro de los contratos colectivos vigentes y reformas/Metadatos.xlsx";
import enero_texto_diccionario from "../docs/lotaip/2024/enero/15. Texto integro de los contratos colectivos vigentes y reformas/Diccionario de datos.xlsx";

import febrero_estructura_datos from "../docs/lotaip/2024/febrero/1.1 estructura-organica/Conjunto de datos.xlsx";
import febrero_estructura_metadatos from "../docs/lotaip/2024/febrero/1.1 estructura-organica/Metadatos.xlsx";
import febrero_estructura_diccionario from "../docs/lotaip/2024/febrero/1.1 estructura-organica/Diccionario de datos.xlsx";

import febrero_base_datos from "../docs/lotaip/2024/febrero/1.2 Base Legal-regulaciones-procedimientos internos/Conjunto de datos.xlsx";
import febrero_base_metadatos from "../docs/lotaip/2024/febrero/1.2 Base Legal-regulaciones-procedimientos internos/Metadatos.xlsx";
import febrero_base_diccionario from "../docs/lotaip/2024/febrero/1.2 Base Legal-regulaciones-procedimientos internos/Diccionario de datos.xlsx";

import febrero_metas_datos from "../docs/lotaip/2024/febrero/1.3 Metas y objetivos-unidades/Conjunto de datos.xlsx";
import febrero_metas_metadatos from "../docs/lotaip/2024/febrero/1.3 Metas y objetivos-unidades/Metadatos.xlsx";
import febrero_metas_diccionario from "../docs/lotaip/2024/febrero/1.3 Metas y objetivos-unidades/Diccionario de datos.xlsx";

import febrero_directorio_datos from "../docs/lotaip/2024/febrero/2. Directorio y distributivo personal de la entidad/Conjunto de datos.xlsx";
import febrero_directorio_metadatos from "../docs/lotaip/2024/febrero/2. Directorio y distributivo personal de la entidad/Metadatos.xlsx";
import febrero_directorio_diccionario from "../docs/lotaip/2024/febrero/2. Directorio y distributivo personal de la entidad/Diccionario de Datos.xlsx";

import febrero_remuneraciones_datos from "../docs/lotaip/2024/febrero/3. Remuneraciones ingresos adicionales_2/Conjunto de datos.xlsx";
import febrero_remuneraciones_metadatos from "../docs/lotaip/2024/febrero/3. Remuneraciones ingresos adicionales_2/Metadatos.xlsx";
import febrero_remuneraciones_diccionario from "../docs/lotaip/2024/febrero/3. Remuneraciones ingresos adicionales_2/Diccionario de datos.xlsx";

import febrero_servicios_datos from "../docs/lotaip/2024/febrero/5-22 Servicios -formularios-formatos-tramites_2/Conjunto de datos.xlsx";
import febrero_servicios_metadatos from "../docs/lotaip/2024/febrero/5-22 Servicios -formularios-formatos-tramites_2/Metadatos.xlsx";
import febrero_servicios_diccionario from "../docs/lotaip/2024/febrero/5-22 Servicios -formularios-formatos-tramites_2/Diccionario de datos.xlsx";

import febrero_presupuesto_datos from "../docs/lotaip/2024/febrero/6. Presupuesto de la institucion/Conjunto de datos.xlsx";
import febrero_presupuesto_metadatos from "../docs/lotaip/2024/febrero/6. Presupuesto de la institucion/Metadatos.xlsx";
import febrero_presupuesto_diccionario from "../docs/lotaip/2024/febrero/6. Presupuesto de la institucion/Diccionario de datos.xlsx";

import febrero_planes_datos from "../docs/lotaip/2024/febrero/10. Planes y programas/Conjunto de datos.xlsx";
import febrero_planes_metadatos from "../docs/lotaip/2024/febrero/10. Planes y programas/Metadatos.xlsx";
import febrero_planes_diccionario from "../docs/lotaip/2024/febrero/10. Planes y programas/Diccionario de datos.xlsx";

import febrero_mecanismo_datos from "../docs/lotaip/2024/febrero/12. Mecanismos rendicion cuentas_2/Conjunto de datos.xlsx";
import febrero_mecanismo_metadatos from "../docs/lotaip/2024/febrero/12. Mecanismos rendicion cuentas_2/Metadatos.xlsx";
import febrero_mecanismo_diccionario from "../docs/lotaip/2024/febrero/12. Mecanismos rendicion cuentas_2/Diccionario.xlsx";

import febrero_responsables_datos from "../docs/lotaip/2024/febrero/14. Responsables del acceso de informacion publica/Conjunto de datos.xlsx";
import febrero_responsables_metadatos from "../docs/lotaip/2024/febrero/14. Responsables del acceso de informacion publica/Metadatos.xlsx";
import febrero_responsables_diccionario from "../docs/lotaip/2024/febrero/14. Responsables del acceso de informacion publica/Diccionario.xlsx";

import febrero_texto_datos from "../docs/lotaip/2024/febrero/15. Texto integro de los contratos colectivos vigentes y reformas/Conjunto de datos.xlsx";
import febrero_texto_metadatos from "../docs/lotaip/2024/febrero/15. Texto integro de los contratos colectivos vigentes y reformas/Metadatos.xlsx";
import febrero_texto_diccionario from "../docs/lotaip/2024/febrero/15. Texto integro de los contratos colectivos vigentes y reformas/Diccionario de datos.xlsx";

import marzo_estructura_datos from "../docs/lotaip/2024/marzo/1.1 estructura-organica/Conjunto de datos.xlsx";
import marzo_estructura_metadatos from "../docs/lotaip/2024/marzo/1.1 estructura-organica/Metadatos.xlsx";
import marzo_estructura_diccionario from "../docs/lotaip/2024/marzo/1.1 estructura-organica/Diccionario de datos.xlsx";

import marzo_base_datos from "../docs/lotaip/2024/marzo/1.2 Base Legal-regulaciones-procedimientos internos/Conjunto de datos.xlsx";
import marzo_base_metadatos from "../docs/lotaip/2024/marzo/1.2 Base Legal-regulaciones-procedimientos internos/Metadatos.xlsx";
import marzo_base_diccionario from "../docs/lotaip/2024/marzo/1.2 Base Legal-regulaciones-procedimientos internos/Diccionario de datos.xlsx";

import marzo_metas_datos from "../docs/lotaip/2024/marzo/1.3 Metas y objetivos-unidades/Conjunto de datos.xlsx";
import marzo_metas_metadatos from "../docs/lotaip/2024/marzo/1.3 Metas y objetivos-unidades/Metadatos.xlsx";
import marzo_metas_diccionario from "../docs/lotaip/2024/marzo/1.3 Metas y objetivos-unidades/Diccionario de datos.xlsx";

import marzo_directorio_datos from "../docs/lotaip/2024/marzo/2. Directorio y distributivo personal de la entidad/Conjunto de datos.xlsx";
import marzo_directorio_metadatos from "../docs/lotaip/2024/marzo/2. Directorio y distributivo personal de la entidad/Metadatos.xlsx";
import marzo_directorio_diccionario from "../docs/lotaip/2024/marzo/2. Directorio y distributivo personal de la entidad/Diccionario de Datos.xlsx";

import marzo_remuneraciones_datos from "../docs/lotaip/2024/marzo/3. Remuneraciones ingresos adicionales_2/Conjunto de datos.xlsx";
import marzo_remuneraciones_metadatos from "../docs/lotaip/2024/marzo/3. Remuneraciones ingresos adicionales_2/Metadatos.xlsx";
import marzo_remuneraciones_diccionario from "../docs/lotaip/2024/marzo/3. Remuneraciones ingresos adicionales_2/Diccionario de datos.xlsx";

import marzo_servicios_datos from "../docs/lotaip/2024/marzo/5-22 Servicios -formularios-formatos-tramites_2/Conjunto de datos.xlsx";
import marzo_servicios_metadatos from "../docs/lotaip/2024/marzo/5-22 Servicios -formularios-formatos-tramites_2/Metadatos.xlsx";
import marzo_servicios_diccionario from "../docs/lotaip/2024/marzo/5-22 Servicios -formularios-formatos-tramites_2/Diccionario de datos.xlsx";

import marzo_presupuesto_datos from "../docs/lotaip/2024/marzo/6. Presupuesto de la institucion/Conjunto de datos.xlsx";
import marzo_presupuesto_metadatos from "../docs/lotaip/2024/marzo/6. Presupuesto de la institucion/Metadatos.xlsx";
import marzo_presupuesto_diccionario from "../docs/lotaip/2024/marzo/6. Presupuesto de la institucion/Diccionario de datos.xlsx";

import marzo_planes_datos from "../docs/lotaip/2024/marzo/10. Planes y programas/Conjunto de datos.xlsx";
import marzo_planes_metadatos from "../docs/lotaip/2024/marzo/10. Planes y programas/Metadatos.xlsx";
import marzo_planes_diccionario from "../docs/lotaip/2024/marzo/10. Planes y programas/Diccionario de datos.xlsx";

import marzo_mecanismo_datos from "../docs/lotaip/2024/marzo/12. Mecanismos rendicion cuentas_2/Conjunto de datos.xlsx";
import marzo_mecanismo_metadatos from "../docs/lotaip/2024/marzo/12. Mecanismos rendicion cuentas_2/Metadatos.xlsx";
import marzo_mecanismo_diccionario from "../docs/lotaip/2024/marzo/12. Mecanismos rendicion cuentas_2/Diccionario.xlsx";

import marzo_responsables_datos from "../docs/lotaip/2024/marzo/14. Responsables del acceso de informacion publica/Conjunto de datos.xlsx";
import marzo_responsables_metadatos from "../docs/lotaip/2024/marzo/14. Responsables del acceso de informacion publica/Metadatos.xlsx";
import marzo_responsables_diccionario from "../docs/lotaip/2024/marzo/14. Responsables del acceso de informacion publica/Diccionario.xlsx";

import marzo_texto_datos from "../docs/lotaip/2024/marzo/15. Texto integro de los contratos colectivos vigentes y reformas/Conjunto de datos.xlsx";
import marzo_texto_metadatos from "../docs/lotaip/2024/marzo/15. Texto integro de los contratos colectivos vigentes y reformas/Metadatos.xlsx";
import marzo_texto_diccionario from "../docs/lotaip/2024/marzo/15. Texto integro de los contratos colectivos vigentes y reformas/Diccionario de datos.xlsx";

import abril_estructura_datos from "../docs/lotaip/2024/abril/1.1 estructura-organica/Conjunto de datos.xlsx";
import abril_estructura_metadatos from "../docs/lotaip/2024/abril/1.1 estructura-organica/Metadatos.xlsx";
import abril_estructura_diccionario from "../docs/lotaip/2024/abril/1.1 estructura-organica/Diccionario de datos.xlsx";

import abril_base_datos from "../docs/lotaip/2024/abril/1.2 Base Legal-regulaciones-procedimientos internos/Conjunto de datos.xlsx";
import abril_base_metadatos from "../docs/lotaip/2024/abril/1.2 Base Legal-regulaciones-procedimientos internos/Metadatos.xlsx";
import abril_base_diccionario from "../docs/lotaip/2024/abril/1.2 Base Legal-regulaciones-procedimientos internos/Diccionario de datos.xlsx";

import abril_metas_datos from "../docs/lotaip/2024/abril/1.3 Metas y objetivos-unidades/Conjunto de datos.xlsx";
import abril_metas_metadatos from "../docs/lotaip/2024/abril/1.3 Metas y objetivos-unidades/Metadatos.xlsx";
import abril_metas_diccionario from "../docs/lotaip/2024/abril/1.3 Metas y objetivos-unidades/Diccionario de datos.xlsx";

import abril_directorio_datos from "../docs/lotaip/2024/abril/2. Directorio y distributivo personal de la entidad/Conjunto de datos.xlsx";
import abril_directorio_metadatos from "../docs/lotaip/2024/abril/2. Directorio y distributivo personal de la entidad/Metadatos.xlsx";
import abril_directorio_diccionario from "../docs/lotaip/2024/abril/2. Directorio y distributivo personal de la entidad/Diccionario de Datos.xlsx";

import abril_remuneraciones_datos from "../docs/lotaip/2024/abril/3. Remuneraciones ingresos adicionales_2/Conjunto de datos.xlsx";
import abril_remuneraciones_metadatos from "../docs/lotaip/2024/abril/3. Remuneraciones ingresos adicionales_2/Metadatos.xlsx";
import abril_remuneraciones_diccionario from "../docs/lotaip/2024/abril/3. Remuneraciones ingresos adicionales_2/Diccionario de datos.xlsx";

import abril_servicios_datos from "../docs/lotaip/2024/abril/5-22 Servicios -formularios-formatos-tramites_2/Conjunto de datos.xlsx";
import abril_servicios_metadatos from "../docs/lotaip/2024/abril/5-22 Servicios -formularios-formatos-tramites_2/Metadatos.xlsx";
import abril_servicios_diccionario from "../docs/lotaip/2024/abril/5-22 Servicios -formularios-formatos-tramites_2/Diccionario de datos.xlsx";

import abril_presupuesto_datos from "../docs/lotaip/2024/abril/6. Presupuesto de la institucion/Conjunto de datos.xlsx";
import abril_presupuesto_metadatos from "../docs/lotaip/2024/abril/6. Presupuesto de la institucion/Metadatos.xlsx";
import abril_presupuesto_diccionario from "../docs/lotaip/2024/abril/6. Presupuesto de la institucion/Diccionario de datos.xlsx";

import abril_planes_datos from "../docs/lotaip/2024/abril/10. Planes y programas/Conjunto de datos.xlsx";
import abril_planes_metadatos from "../docs/lotaip/2024/abril/10. Planes y programas/Metadatos.xlsx";
import abril_planes_diccionario from "../docs/lotaip/2024/abril/10. Planes y programas/Diccionario de datos.xlsx";

import abril_mecanismo_datos from "../docs/lotaip/2024/abril/12. Mecanismos rendicion cuentas_2/Conjunto de datos.xlsx";
import abril_mecanismo_metadatos from "../docs/lotaip/2024/abril/12. Mecanismos rendicion cuentas_2/Metadatos.xlsx";
import abril_mecanismo_diccionario from "../docs/lotaip/2024/abril/12. Mecanismos rendicion cuentas_2/Diccionario.xlsx";

import abril_responsables_datos from "../docs/lotaip/2024/abril/14. Responsables del acceso de informacion publica/Conjunto de datos.xlsx";
import abril_responsables_metadatos from "../docs/lotaip/2024/abril/14. Responsables del acceso de informacion publica/Metadatos.xlsx";
import abril_responsables_diccionario from "../docs/lotaip/2024/abril/14. Responsables del acceso de informacion publica/Diccionario.xlsx";

import abril_texto_datos from "../docs/lotaip/2024/abril/15. Texto integro de los contratos colectivos vigentes y reformas/Conjunto de datos.xlsx";
import abril_texto_metadatos from "../docs/lotaip/2024/abril/15. Texto integro de los contratos colectivos vigentes y reformas/Metadatos.xlsx";
import abril_texto_diccionario from "../docs/lotaip/2024/abril/15. Texto integro de los contratos colectivos vigentes y reformas/Diccionario de datos.xlsx";
import informe_2024 from "../docs/lotaip/2024/informe.pdf"
function Lotaip2024() {
  return (
    <>
      <Accordion
        title="LOTAIP 2024"
        content={
          <>

          <a href={informe_2024}>Informe anual 2024</a>
          <br></br>
            <Accordion
              title="Enero"
              content={
                <div className="section-acc">
                  <Accordion
                    title="1.1 Estructura orgánica"
                    content={
                      <>
                        <a href={enero_estructura_datos}>Conjunto de datos</a>
                        <a href={enero_estructura_metadatos}>Metadatos</a>
                        <a href={enero_estructura_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="1.2 Base legal regulaciones procedimientos internos"
                    content={
                      <>
                        <a href={enero_base_datos}>Conjunto de datos</a>
                        <a href={enero_base_metadatos}>Metadatos</a>
                        <a href={enero_base_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="1.3 Metas y objetivos"
                    content={
                      <>
                        <a href={enero_metas_datos}>Conjunto de datos</a>
                        <a href={enero_metas_metadatos}>Metadatos</a>
                        <a href={enero_metas_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="2. Directorio y distributivo personal de la entidad"
                    content={
                      <>
                        <a href={enero_directorio_datos}>Conjunto de datos</a>
                        <a href={enero_directorio_metadatos}>Metadatos</a>
                        <a href={enero_directorio_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="3. Remuneraciones ingresos adicionales"
                    content={
                      <>
                        <a href={enero_remuneraciones_datos}>
                          Conjunto de datos
                        </a>
                        <a href={enero_remuneraciones_metadatos}>Metadatos</a>
                        <a href={enero_remuneraciones_diccionario}>
                          Diccionario
                        </a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="5-22 Servicios-formularios-formatos-trámites"
                    content={
                      <>
                        <a href={enero_servicios_datos}>Conjunto de datos</a>
                        <a href={enero_servicios_metadatos}>Metadatos</a>
                        <a href={enero_servicios_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="6. Presupuesto de la institucion"
                    content={
                      <>
                        <a href={enero_presupuesto_datos}>Conjunto de datos</a>
                        <a href={enero_presupuesto_metadatos}>Metadatos</a>
                        <a href={enero_presupuesto_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="10. Planes y programas"
                    content={
                      <>
                        <a href={enero_planes_datos}>Conjunto de datos</a>
                        <a href={enero_planes_metadatos}>Metadatos</a>
                        <a href={enero_planes_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="12. Mecanismos rendicion cuentas"
                    content={
                      <>
                        <a href={enero_mecanismo_datos}>Conjunto de datos</a>
                        <a href={enero_mecanismo_metadatos}>Metadatos</a>
                        <a href={enero_mecanismo_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="14. Responsables del acceso de informacion publica"
                    content={
                      <>
                        <a href={enero_responsables_datos}>Conjunto de datos</a>
                        <a href={enero_responsables_metadatos}>Metadatos</a>
                        <a href={enero_responsables_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="15. Texto integro de los contratos colectivos vigentes y reformas"
                    content={
                      <>
                        <a href={enero_texto_datos}>Conjunto de datos</a>
                        <a href={enero_texto_metadatos}>Metadatos</a>
                        <a href={enero_texto_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                </div>
              }
            ></Accordion>

            <Accordion
              title="Febrero"
              content={
                <div className="section-acc">
                  <Accordion
                    title="1.1 Estructura orgánica"
                    content={
                      <>
                        <a href={febrero_estructura_datos}>Conjunto de datos</a>
                        <a href={febrero_estructura_metadatos}>Metadatos</a>
                        <a href={febrero_estructura_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="1.2 Base legal regulaciones procedimientos internos"
                    content={
                      <>
                        <a href={febrero_base_datos}>Conjunto de datos</a>
                        <a href={febrero_base_metadatos}>Metadatos</a>
                        <a href={febrero_base_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="1.3 Metas y objetivos"
                    content={
                      <>
                        <a href={febrero_metas_datos}>Conjunto de datos</a>
                        <a href={febrero_metas_metadatos}>Metadatos</a>
                        <a href={febrero_metas_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="2. Directorio y distributivo personal de la entidad"
                    content={
                      <>
                        <a href={febrero_directorio_datos}>Conjunto de datos</a>
                        <a href={febrero_directorio_metadatos}>Metadatos</a>
                        <a href={febrero_directorio_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="3. Remuneraciones ingresos adicionales"
                    content={
                      <>
                        <a href={febrero_remuneraciones_datos}>
                          Conjunto de datos
                        </a>
                        <a href={febrero_remuneraciones_metadatos}>Metadatos</a>
                        <a href={febrero_remuneraciones_diccionario}>
                          Diccionario
                        </a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="5-22 Servicios-formularios-formatos-trámites"
                    content={
                      <>
                        <a href={febrero_servicios_datos}>Conjunto de datos</a>
                        <a href={febrero_servicios_metadatos}>Metadatos</a>
                        <a href={febrero_servicios_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="6. Presupuesto de la institucion"
                    content={
                      <>
                        <a href={febrero_presupuesto_datos}>
                          Conjunto de datos
                        </a>
                        <a href={febrero_presupuesto_metadatos}>Metadatos</a>
                        <a href={febrero_presupuesto_diccionario}>
                          Diccionario
                        </a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="10. Planes y programas"
                    content={
                      <>
                        <a href={febrero_planes_datos}>Conjunto de datos</a>
                        <a href={febrero_planes_metadatos}>Metadatos</a>
                        <a href={febrero_planes_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="12. Mecanismos rendicion cuentas"
                    content={
                      <>
                        <a href={febrero_mecanismo_datos}>Conjunto de datos</a>
                        <a href={febrero_mecanismo_metadatos}>Metadatos</a>
                        <a href={febrero_mecanismo_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="14. Responsables del acceso de informacion publica"
                    content={
                      <>
                        <a href={febrero_responsables_datos}>
                          Conjunto de datos
                        </a>
                        <a href={febrero_responsables_metadatos}>Metadatos</a>
                        <a href={febrero_responsables_diccionario}>
                          Diccionario
                        </a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="15. Texto integro de los contratos colectivos vigentes y reformas"
                    content={
                      <>
                        <a href={febrero_texto_datos}>Conjunto de datos</a>
                        <a href={febrero_texto_metadatos}>Metadatos</a>
                        <a href={febrero_texto_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                </div>
              }
            ></Accordion>

            <Accordion
              title="Marzo"
              content={
                <div className="section-acc">
                  <Accordion
                    title="1.1 Estructura orgánica"
                    content={
                      <>
                        <a href={marzo_estructura_datos}>Conjunto de datos</a>
                        <a href={marzo_estructura_metadatos}>Metadatos</a>
                        <a href={marzo_estructura_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="1.2 Base legal regulaciones procedimientos internos"
                    content={
                      <>
                        <a href={marzo_base_datos}>Conjunto de datos</a>
                        <a href={marzo_base_metadatos}>Metadatos</a>
                        <a href={marzo_base_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="1.3 Metas y objetivos"
                    content={
                      <>
                        <a href={marzo_metas_datos}>Conjunto de datos</a>
                        <a href={marzo_metas_metadatos}>Metadatos</a>
                        <a href={marzo_metas_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="2. Directorio y distributivo personal de la entidad"
                    content={
                      <>
                        <a href={marzo_directorio_datos}>Conjunto de datos</a>
                        <a href={marzo_directorio_metadatos}>Metadatos</a>
                        <a href={marzo_directorio_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="3. Remuneraciones ingresos adicionales"
                    content={
                      <>
                        <a href={marzo_remuneraciones_datos}>
                          Conjunto de datos
                        </a>
                        <a href={marzo_remuneraciones_metadatos}>Metadatos</a>
                        <a href={marzo_remuneraciones_diccionario}>
                          Diccionario
                        </a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="5-22 Servicios-formularios-formatos-trámites"
                    content={
                      <>
                        <a href={marzo_servicios_datos}>Conjunto de datos</a>
                        <a href={marzo_servicios_metadatos}>Metadatos</a>
                        <a href={marzo_servicios_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="6. Presupuesto de la institucion"
                    content={
                      <>
                        <a href={marzo_presupuesto_datos}>Conjunto de datos</a>
                        <a href={marzo_presupuesto_metadatos}>Metadatos</a>
                        <a href={marzo_presupuesto_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="10. Planes y programas"
                    content={
                      <>
                        <a href={marzo_planes_datos}>Conjunto de datos</a>
                        <a href={marzo_planes_metadatos}>Metadatos</a>
                        <a href={marzo_planes_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="12. Mecanismos rendicion cuentas"
                    content={
                      <>
                        <a href={marzo_mecanismo_datos}>Conjunto de datos</a>
                        <a href={marzo_mecanismo_metadatos}>Metadatos</a>
                        <a href={marzo_mecanismo_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="14. Responsables del acceso de informacion publica"
                    content={
                      <>
                        <a href={marzo_responsables_datos}>Conjunto de datos</a>
                        <a href={marzo_responsables_metadatos}>Metadatos</a>
                        <a href={marzo_responsables_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="15. Texto integro de los contratos colectivos vigentes y reformas"
                    content={
                      <>
                        <a href={marzo_texto_datos}>Conjunto de datos</a>
                        <a href={marzo_texto_metadatos}>Metadatos</a>
                        <a href={marzo_texto_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                </div>
              }
            ></Accordion>

            <Accordion
              title="Abril"
              content={
                <>
                  <Accordion
                    title="1.1 Estructura orgánica"
                    content={
                      <>
                        <a href={abril_estructura_datos}>Conjunto de datos</a>
                        <a href={abril_estructura_metadatos}>Metadatos</a>
                        <a href={abril_estructura_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="1.2 Base legal regulaciones procedimientos internos"
                    content={
                      <>
                        <a href={abril_base_datos}>Conjunto de datos</a>
                        <a href={abril_base_metadatos}>Metadatos</a>
                        <a href={abril_base_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="1.3 Metas y objetivos"
                    content={
                      <>
                        <a href={abril_metas_datos}>Conjunto de datos</a>
                        <a href={abril_metas_metadatos}>Metadatos</a>
                        <a href={abril_metas_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="2. Directorio y distributivo personal de la entidad"
                    content={
                      <>
                        <a href={abril_directorio_datos}>Conjunto de datos</a>
                        <a href={abril_directorio_metadatos}>Metadatos</a>
                        <a href={abril_directorio_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="3. Remuneraciones ingresos adicionales"
                    content={
                      <>
                        <a href={abril_remuneraciones_datos}>
                          Conjunto de datos
                        </a>
                        <a href={abril_remuneraciones_metadatos}>Metadatos</a>
                        <a href={abril_remuneraciones_diccionario}>
                          Diccionario
                        </a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="5-22 Servicios-formularios-formatos-trámites"
                    content={
                      <>
                        <a href={abril_servicios_datos}>Conjunto de datos</a>
                        <a href={abril_servicios_metadatos}>Metadatos</a>
                        <a href={abril_servicios_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="6. Presupuesto de la institucion"
                    content={
                      <>
                        <a href={abril_presupuesto_datos}>Conjunto de datos</a>
                        <a href={abril_presupuesto_metadatos}>Metadatos</a>
                        <a href={abril_presupuesto_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="10. Planes y programas"
                    content={
                      <>
                        <a href={abril_planes_datos}>Conjunto de datos</a>
                        <a href={abril_planes_metadatos}>Metadatos</a>
                        <a href={abril_planes_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="12. Mecanismos rendicion cuentas"
                    content={
                      <>
                        <a href={abril_mecanismo_datos}>Conjunto de datos</a>
                        <a href={abril_mecanismo_metadatos}>Metadatos</a>
                        <a href={abril_mecanismo_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="14. Responsables del acceso de informacion publica"
                    content={
                      <>
                        <a href={abril_responsables_datos}>Conjunto de datos</a>
                        <a href={abril_responsables_metadatos}>Metadatos</a>
                        <a href={abril_responsables_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="15. Texto integro de los contratos colectivos vigentes y reformas"
                    content={
                      <>
                        <a href={abril_texto_datos}>Conjunto de datos</a>
                        <a href={abril_texto_metadatos}>Metadatos</a>
                        <a href={abril_texto_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                </>
              }
            ></Accordion>
          </>
        }
      ></Accordion>
    </>
  );
}

export default Lotaip2024;
